module.exports = __webpack_public_path__ + "static/img/5.5f329ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/5.png
// module id = 4W7I
// module chunks = 0